import styled from 'styled-components'
import { useContext } from 'react'

export const Loader = ({lang}: { lang: 'de' | 'fr' }) => {
  return (
    <LoaderContainer>
      {lang === 'fr' ? 'Évaluation en cours.' : 'Auswertung wird erstellt'}
      <br />
      <Spinner />
    </LoaderContainer>
  )
}

const LoaderContainer = styled.div`
  text-align: center;
  max-width: 450px;
  font-size: 12px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4em;
  margin-bottom: 30px;
  margin-top: 120px;
  color: var(--gray-3);
  @media screen and (max-width: 711px) {
    max-width: calc(100vw - 30px);
  }
`

const Spinner = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--text-color);
  box-shadow: 32px 0 var(--text-color), -32px 0 var(--text-color);
  position: relative;
  animation: flash 0.3s ease-in infinite alternate;
  transform: scale(0.3);
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  &::before,
  &::after {
    content: '';
    position: absolute;
    left: -64px;
    top: 0;
    background: var(--text-color);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    transform-origin: 35px -35px;
    transform: rotate(45deg);
    animation: hitL 0.3s ease-in infinite alternate;
  }

  &::after {
    left: 64px;
    transform: rotate(-45deg);
    transform-origin: -35px -35px;
    animation: hitR 0.3s ease-out infinite alternate;
  }

  @keyframes flash {
    0%,
    100% {
      background-color: rgba(100, 100, 100, 0.25);
      box-shadow: 32px 0 rgba(100, 100, 100, 0.25),
        -32px 0 rgba(100, 100, 100, 0.25);
    }
    25% {
      background-color: rgba(100, 100, 100, 0.25);
      box-shadow: 32px 0 rgba(100, 100, 100, 0.25),
        -32px 0 rgba(100, 100, 100, 1);
    }
    50% {
      background-color: rgba(100, 100, 100, 1);
      box-shadow: 32px 0 rgba(100, 100, 100, 0.25),
        -32px 0 rgba(100, 100, 100, 0.25);
    }
    75% {
      background-color: rgba(100, 100, 100, 0.25);
      box-shadow: 32px 0 rgba(100, 100, 100, 1),
        -32px 0 rgba(100, 100, 100, 0.25);
    }
  }

  @keyframes hitL {
    0% {
      transform: rotate(45deg);
      background-color: rgba(100, 100, 100, 1);
    }
    25%,
    100% {
      transform: rotate(0deg);
      background-color: rgba(100, 100, 100, 0.25);
    }
  }

  @keyframes hitR {
    0%,
    75% {
      transform: rotate(0deg);
      background-color: rgba(100, 100, 100, 0.25);
    }
    100% {
      transform: rotate(-45deg);
      background-color: rgba(100, 100, 100, 1);
    }
  }
`
